import { useState } from 'react';
import { ZoomIn, X } from 'lucide-react';
import dashboardScreenshot from '../assets/dashboard_screenshot_1767892372435.png';
import calendarScreenshot from '../assets/calendar_screenshot_1767892401066.png';
import clientsScreenshot from '../assets/clients_screenshot_1767892423501.png';
import financesScreenshot from '../assets/finances_screenshot_1767892451442.png';

/**
 * ScreenshotsSection Component - Premium Dark Design
 * 
 * Interactive gallery showcasing application screenshots.
 * Features modal view for enlarged images and smooth transitions.
 */
function ScreenshotsSection() {
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const screenshots = [
        {
            src: dashboardScreenshot,
            alt: 'Dashboard Principal',
            title: 'Dashboard Principal',
            description: 'Vista general con estadísticas en tiempo real'
        },
        {
            src: calendarScreenshot,
            alt: 'Agenda Semanal',
            title: 'Agenda Semanal',
            description: 'Calendario interactivo con todas tus citas'
        },
        {
            src: clientsScreenshot,
            alt: 'Gestión de Clientes',
            title: 'Gestión de Clientes',
            description: 'CRM completo con historial y búsqueda'
        },
        {
            src: financesScreenshot,
            alt: 'Panel Financiero',
            title: 'Panel Financiero',
            description: 'Reportes detallados y análisis de ingresos'
        }
    ];

    const openModal = (src: string) => {
        setSelectedImage(src);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedImage(null);
        document.body.style.overflow = 'auto';
    };

    return (
        <section id="screenshots" className="screenshots-section">
            <div className="section-container">
                <div className="section-header">
                    <span className="section-badge">GALERÍA</span>
                    <h2 className="section-title">
                        Interfaz moderna y
                        <span className="gradient-text"> fácil de usar</span>
                    </h2>
                    <p className="section-description">
                        Diseñada para que puedas enfocarte en lo que realmente importa: tus clientes.
                        <strong> Intuitiva, rápida y hermosa.</strong>
                    </p>
                </div>

                <div className="screenshots-grid">
                    {screenshots.map((screenshot, index) => (
                        <div
                            key={index}
                            className="screenshot-card cursor-pointer"
                            onClick={() => openModal(screenshot.src)}
                        >
                            <div className="screenshot-image-wrapper">
                                <img
                                    src={screenshot.src}
                                    alt={screenshot.alt}
                                    className="screenshot-image"
                                />
                                <div className="screenshot-overlay">
                                    <ZoomIn className="text-white w-12 h-12" />
                                </div>
                            </div>
                            <div className="screenshot-info">
                                <h3 className="screenshot-title">{screenshot.title}</h3>
                                <p className="screenshot-description">{screenshot.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal for enlarged view */}
            {selectedImage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md p-4 animate-in fade-in duration-200"
                    onClick={closeModal}
                >
                    <button
                        className="absolute top-4 right-4 text-white hover:text-emerald-400 transition-colors bg-white/10 rounded-full p-2"
                        onClick={closeModal}
                    >
                        <X size={32} />
                    </button>

                    <div
                        className="relative max-w-7xl max-h-[90vh] rounded-xl overflow-hidden shadow-2xl animate-in zoom-in-95 duration-300"
                        onClick={e => e.stopPropagation()}
                    >
                        <img
                            src={selectedImage}
                            alt="Screenshot ampliado"
                            className="w-full h-full object-contain max-h-[90vh]"
                        />
                    </div>
                </div>
            )}
        </section>
    );
}

export default ScreenshotsSection;
